// The marketing pages: the ones a crawler should read as real HTML.
// Both the browser router (App.jsx) and the prerender build
// (entry-server.jsx) take their routes from here, so a page added
// once is served, indexed, and listed in the sitemap.
import React from 'react';
import Furniture from '../pages/Furniture';
import SalesAssistant from '../pages/services/SalesAssistant';
import Website from '../pages/services/Website';
import WebsiteAgent from '../pages/services/WebsiteAgent';
import PhoneAgent from '../pages/services/PhoneAgent';
import DigitalReceipt from '../pages/services/DigitalReceipt';
import Reviews from '../pages/services/Reviews';
import AiSearch from '../pages/services/AiSearch';
import Websites from '../pages/services/Websites';

export const MARKETING_ROUTES = [
  { path: '/', element: <Furniture /> },
  { path: '/sales-assistant', element: <SalesAssistant /> },
  { path: '/website', element: <Website /> },
  { path: '/website-agent', element: <WebsiteAgent /> },
  { path: '/phone-agent', element: <PhoneAgent /> },
  { path: '/digital-receipt', element: <DigitalReceipt /> },
  { path: '/reviews', element: <Reviews /> },
  { path: '/ai-search', element: <AiSearch /> },
  { path: '/websites', element: <Websites /> },
];
